export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  testId,
}) {
  const alignment =
    align === "center"
      ? "items-center text-center mx-auto"
      : "items-start text-left";

  return (
    <div
      data-testid={testId}
      className={`max-w-3xl flex flex-col gap-4 ${alignment}`}
    >
      {eyebrow && <span className="overline">{eyebrow}</span>}
      <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-[1.05] font-bold text-slate-900">
        {title}
      </h2>
      {description && (
        <p className="text-base md:text-lg text-slate-600 leading-relaxed font-light">
          {description}
        </p>
      )}
    </div>
  );
}
